import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import { SelectValue } from '../../../Base/Select/Select';
import ErrorMessage from '../ErrorMessage';
import Select, { SelectProps } from '../Select';
import TopFieldContent from '../TopFieldContent';

interface SelectFieldProps extends SelectProps {
	name: string;
	label?: string;
	className?: string;
	isRequired?: boolean;
	onFieldChange?: (...event: any) => void;
	portal?: boolean;
	isFixed?: boolean;
	isSearchable?: boolean;
}

const SelectField = ({
	name,
	label,
	className,
	isRequired,
	onFieldChange,
	portal,
	isFixed,
	isSearchable,
	...selectProps
}: SelectFieldProps) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: {},
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Select
				hasError={Boolean(error)}
				{...selectProps}
				{...field}
				{...(onFieldChange && {
					onChange: event => {
						onFieldChange?.(event);
						field.onChange(event);
					},
				})}
				portal={portal}
				isFixed={isFixed}
				isSearchable={isSearchable}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default SelectField;
